/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData, FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped, FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON, } from './FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData';
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSON(json) {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(json)) {
        return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSON(json) {
    return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSONTyped(json, false);
}
export function FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseData(value)) {
        return FxIdApplicationHandlersAuthConnectTwitchAccountHandlerResponseDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseData.js.map